import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  FiArrowUpRight,
  FiArrowRight,
  FiVideo,
  FiCamera,
  FiFilm,
  FiPenTool,
  FiMonitor,
  FiTrendingUp,
} from "react-icons/fi";
import "./Services.css";

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    number: "01",
    icon: FiVideo,
    title: "End-to-End Video Production",
    tagline: "Stories That Inspire. Content That Performs.",
    description:
      "Complete production solutions from creative concept and scripting to filming, post-production and final delivery.",
    items: [
      "Commercial Video Production",
      "Corporate Films",
      "Brand Storytelling",
      "Product Videos",
    ],
    more: "9 MORE CAPABILITIES",
  },
  {
    number: "02",
    icon: FiCamera,
    title: "Content Production & Management",
    tagline: "Consistency Builds Strong Brands.",
    description:
      "Strategic content planning, production and management designed to keep brands visible, relevant and engaging.",
    items: [
      "Content Strategy",
      "Monthly Content Planning",
      "Creative Direction",
      "Reels & Short Videos",
    ],
    more: "6 MORE CAPABILITIES",
  },
  {
    number: "03",
    icon: FiFilm,
    title: "Films & Commercials",
    tagline: "Powerful Stories. Lasting Impressions.",
    description:
      "Cinematic films and premium commercial productions that create emotional connections and strengthen brand identity.",
    items: [
      "TV & Digital Commercials",
      "Brand Films",
      "Product Launch Videos",
      "Luxury Campaigns",
    ],
    more: "4 MORE CAPABILITIES",
  },
  {
    number: "04",
    icon: FiPenTool,
    title: "Branding",
    tagline: "Build A Brand People Trust.",
    description:
      "Distinctive brand identities and visual systems created to communicate professionalism, consistency and credibility.",
    items: [
      "Brand Strategy",
      "Logo Design",
      "Visual Identity",
      "Brand Guidelines",
    ],
    more: "5 MORE CAPABILITIES",
  },
  {
    number: "05",
    icon: FiMonitor,
    title: "Development",
    tagline: "Digital Experiences Designed To Convert.",
    description:
      "Modern websites and digital experiences that communicate value, establish trust and turn visitors into customers.",
    items: [
      "Business Websites",
      "Landing Pages",
      "UI / UX Design",
      "Custom Development",
    ],
    more: "5 MORE CAPABILITIES",
  },
  {
    number: "06",
    icon: FiTrendingUp,
    title: "Marketing",
    tagline: "Creativity Turned Into Growth.",
    description:
      "Marketing strategy and creative execution designed to increase visibility, generate leads and support sustainable growth.",
    items: [
      "Marketing Strategy",
      "Brand Positioning",
      "Campaign Planning",
      "Growth Consulting",
    ],
    more: "5 MORE CAPABILITIES",
  },
];

function Services() {
  const sectionRef = useRef(null);

  useLayoutEffect(() => {}, []);

  return (
    <section
      className="services-section"
      id="services"
      ref={sectionRef}
    >
      <div className="services-container">
        <header className="services-header">
          <span className="services-eyebrow">
            End-To-End Production
          </span>

          <h2 className="services-heading">
            CREATIVE SOLUTIONS
            <span>BUILT FOR IMPACT</span>
          </h2>

          <p className="services-intro">
            Our services cover creative production, branding, web development, design, and digital
            marketing—delivering complete solutions for modern businesses.
          </p>
        </header>

        <div className="services-grid">
          {services.map((service) => {
            const Icon = service.icon;

            return (
              <article
                className="service-card"
                key={service.number}
              >
                <div className="service-glow">
                  <span className="service-glow-left" />
                  <span className="service-glow-right" />
                  <span className="service-glow-bottom" />
                  <span className="service-glow-core" />
                  <span className="service-glow-rim" />
                  <span className="service-glow-corner" />
                </div>

                <div className="service-card-content">
                  <div className="service-card-top">
                    <span className="service-number">
                      {service.number}
                    </span>

                    <div className="service-icon">
                      <Icon />
                    </div>
                  </div>

                  <div className="service-main">
                    <h3 className="service-title">
                      {service.title}
                    </h3>

                    <p className="service-tagline">
                      {service.tagline}
                    </p>

                    <p className="service-description">
                      {service.description}
                    </p>

                    <div className="service-list">
                      {service.items.map((item) => (
                        <div
                          className="service-list-item"
                          key={item}
                        >
                          <FiArrowUpRight />

                          <span>{item}</span>
                        </div>
                      ))}
                    </div>

                    <span className="service-more">
                      + {service.more}
                    </span>
                  </div>

                  <footer className="service-footer">
                    <span>EXPLORE SERVICE</span>

                    <FiArrowRight />
                  </footer>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Services;